import React from 'react';

type Props = {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  loading?: boolean;
  describedBy?: string;
  invalid?: boolean;
  placeholder?: string;
};

const PhoneField: React.FC<Props> = ({ value, onChange, loading = false, describedBy, invalid = false, placeholder = '0912 345 6789' }) => {
  return (
    <div className="space-y-4 sm:space-y-5">
      <label htmlFor="phone" className="block text-base sm:text-lg font-bold text-[#0e444e] mr-1 text-right mb-2">شماره موبایل</label>
      <div className="relative group">
        <input
          id="phone"
          name="phone"
          type="tel"
          autoComplete="tel"
          required
          value={value}
          onChange={onChange}
          disabled={loading}
          placeholder={placeholder}
          dir="ltr"
          inputMode="tel"
          aria-invalid={invalid}
          aria-describedby={describedBy}
          className="block w-full h-16 px-6 text-xl text-center font-bold tracking-widest text-[#0e444e] bg-gray-50 border-2 border-gray-200 rounded-2xl focus:border-[#d5b481] focus:ring-4 focus:ring-[#d5b481]/20 focus:bg-white transition-all duration-300 outline-none placeholder:text-gray-400 placeholder:font-normal placeholder:tracking-normal disabled:opacity-60 disabled:cursor-not-allowed"
        />
        <div className="absolute inset-y-0 left-5 flex items-center pointer-events-none text-gray-400 group-focus-within:text-[#d5b481] transition-colors">
          <svg className="w-6 h-6 sm:w-7 sm:h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default PhoneField;
